import { createInstance } from 'i18next'
import { initReactI18next } from 'react-i18next'

import en_UK from '@/locales/en_UK/translation.json'

const i18n = createInstance()

void i18n.use(initReactI18next).init({
  lng: 'en_UK',
  fallbackLng: 'en_UK',
  supportedLngs: ['en_UK'],
  resources: {
    en_UK: {
      translation: en_UK,
    },
  },
  interpolation: {
    escapeValue: false,
  },
  returnEmptyString: false,
})

export default i18n
